import { render, staticRenderFns } from "./FormCustomer.vue?vue&type=template&id=e55a5604&scoped=true&"
import script from "./FormCustomer.vue?vue&type=script&lang=js&"
export * from "./FormCustomer.vue?vue&type=script&lang=js&"
import style0 from "./FormCustomer.vue?vue&type=style&index=0&id=e55a5604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55a5604",
  null
  
)

export default component.exports